import _isNil from 'lodash/isNil';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import FoldersApi from '@Data/folders/Api';
import { foldersState, visibleFoldersState } from '@Data/folders/Reducer';
import ProjectsApi from '@Data/projects/Api';
import { selectedProjectState } from '@Data/projects/Reducer';
import { selectedTeamState } from '@Data/teams/Reducer';

export const WorkbenchBaseView = () => {
    const navigate = useNavigate();
    const params = useParams();
    const projectId = params.projectId;
    const folderIds = params.folderIds;

    const selectedTeam = useSelector(selectedTeamState);
    const selectedProject = useSelector(selectedProjectState);
    const folders = useSelector(foldersState);
    const visibleFolders = useSelector(visibleFoldersState);

    useEffect(() => {
        if (_isNil(projectId)) {
            navigate('/');
        }
    }, []);

    useEffect(() => {
        if (!_isNil(selectedTeam) && _isNil(selectedProject)) {
            ProjectsApi.getAndSelectProjectById(
                selectedTeam.team_id,
                parseInt(projectId)
            );
        }
    }, [selectedProject, selectedTeam]);

    useEffect(() => {
        const getFolders = async () => {
            await FoldersApi.getFolders(selectedProject.project_id);
        };

        if (!_isNil(selectedProject) && _isNil(folders)) {
            getFolders();
        }
    }, [selectedProject]);

    useEffect(() => {
        const setSelectedFolders = () => {
            const parsedFolders = folderIds
                .split(',')
                .map((folderId) =>
                    folders.find((f) => f.folder_id === folderId)
                )
                .filter((folder) => !_isNil(folder));
            FoldersApi.setMultipleFolderVisibility(parsedFolders, () => {
                if (parsedFolders.length === 1) {
                    FoldersApi.zoomToBounds(
                        parsedFolders[0].folder_id,
                        visibleFolders.map((f) => f.folder_id)
                    );
                }
            });
        };

        if (
            !_isNil(folders) &&
            !_isNil(folderIds) &&
            visibleFolders.length === 0
        ) {
            setSelectedFolders();
        }
    }, [folders, visibleFolders, folderIds]);

    return <Outlet />;
};
